
export class WizardPayloadModel {
    public type: string;
	public payload: any;
	
	public constructor(payload: any, type: string = "navigation") {
		this.type = type;
		this.payload = payload;
	}
}
